/**
 * @author zk
 * @description 记录用户日志
 * @Date 2019/12/28
 */
import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateCofig } from "./config";

import { component_tool, framework_tool } from '@/tool';
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport } = component_tool;


class SyncTimsTransfer extends WizContainer {
  componentName = 'syncTimsTransfer';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _onUpdate = (record, other = {}) => {
    this.setState({
      record,
      visible: true,
      ...other
    });
  };


  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }
  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD
      },
      templateConfig,
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(SyncTimsTransfer);
